// extracted by mini-css-extract-plugin
export default {"mainHeading":"RailZoneFinder_mainHeading__fd3KV","backLink":"RailZoneFinder_backLink__0Krw+","bgWhite":"RailZoneFinder_bgWhite__rmpT+"};